<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Assessment Timeline</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div class="table-responsive" v-if="!loading">
              <table class="table table-striped dt-responsive w-100 mb-3" id="datatable" v-if="!loading">
                <thead v-if="!loading">
                  <tr>
                    <th>No.</th>
                    <th>Employee ID</th>
                    <th>Employee Name</th>
                    <th>Module</th>
                    <th>Business Unit</th>
                    <th>Training Date</th>
                    <th>Trainer Name</th>
                    <th>Expire Date</th>
                    <th>User Status</th>
                    <th>Active Status</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in assessment_timeline" :key="data.id" v-if="assessment_timeline.length > 0">
                    <td>{{ index + 1 }}</td>
                    <td>{{ data.enrolled_user_id || data.employee_id || '-' }}</td>
                    <td>{{ getEmployeeName(data) }}</td>
                    <td>{{ data.monthly_plan?.module?.name || '-' }}</td>
                    <td>{{ data.business_unit_name}}</td>
                    <td>{{ data.monthly_plan?.from_date }}</td>
                    <td>{{ data.trainer_names }}</td>
                    <td>{{ data.expire_date }}</td>
                    <td>{{ isResigned(data) }}</td>
                    <td>{{ getActiveStatus(data) }}</td>
                    <td>{{ getStatusText(data.status) }}</td>
                    <td>
                      <router-link v-if="hasPermissions(['self-assessment-timeline-edit'])"
                        class="action-icon" :to="{
                        name: 'after-month-assessment-timeline-edit',
                        params: { id: data.id },
                      }">
                        <i class="mdi mdi-square-edit-outline"></i>
                      </router-link>
                    </td>
                  </tr>

                  <!-- Empty state -->
                  <tr v-else>
                    <td colspan="9" class="text-center py-4 text-muted">
                      No assessment timeline data available
                    </td>
                  </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Datatable Program Timeline
import "datatables.net/js/jquery.dataTables.min.js";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-bs5/js/dataTables.bootstrap5.min.js";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-responsive-bs5/js/responsive.bootstrap5.min.js";
import $ from "jquery";
import axios from "axios";
import { useToast } from "vue-toastification";
import badgeSuccess from "../../../components/shared/badgeSuccess.vue";
import badgeDanger from "../../../components/shared/badgeDanger.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
//Mixins
import userHasPermissions from "../../../mixins/userHasPermissions";

export default {
  name: 'AssessmentTimeline',
  components: {
    badgeSuccess,
    badgeDanger,
    vSelect,
  },
  mixins: [userHasPermissions],
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      employees: [],
      assessment_timeline: [],
      status: "",
      arr_status: [{ name: "Active" }, { name: "Inactive" }],
      loading: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      dataTableInstance: null
    };
  },
  methods: {
    getEmployeeName(data) {
      // Check for employee name in different possible locations
      if (data.enrolled_user?.name) {
        return data.enrolled_user.name;
      } else if (data.name) {
        return data.name;
      } else if (data.enrolled_user_id) {
        // Try to find in employees array
        const employee = this.employees.find(emp => emp.emp_id === data.enrolled_user_id);
        return employee ? employee.name : data.enrolled_user_id;
      }
      return '-';
    },

    getStatusText(status) {
      // Map status codes to text
      switch (parseInt(status)) {
        case 0:
          return 'Waiting';
        case 1:
          return 'On Progress';
        case 2:
          return 'Complete';
        case 3:
          return 'Cancel'
        default:
          return 'Draft';
      }
    },

    getStatusClass(status) {
      // Map status codes to CSS classes
      switch (parseInt(status)) {
        case 0: // Waiting
          return 'badge-warning';
        case 1: // Pending
          return 'badge-info';
        case 2: // Complete
          return 'badge-success';
        default:
          return 'badge-secondary';
      }
    },

    async getAssessmentTimeline() {
      this.loading = true;
      this.$Progress.start();
      try {
        const response = await axios.get(`${this.baseUrl}admin/v2/self-assessment`);
        this.assessment_timeline = response.data.data || [];
        this.loading = false;
        this.$Progress.finish();
        // Initialize DataTable after data is loaded
        this.$nextTick(() => {
          if (this.assessment_timeline.length > 0) {
            this.initializeDataTable();
          }
        });
      } catch (error) {
        console.error('Error fetching assessment timeline:', error);
        this.errors = error.response?.data?.errors || {};
        this.toast.error("Something Went Wrong!");
        this.loading = false;
        this.$Progress.fail();
      }
      console.log("assessment list", this.assessment_timeline)
    },

    initializeDataTable() {
      // Destroy existing DataTable instance if it exists
      if (this.dataTableInstance) {
        this.dataTableInstance.destroy();
      }

      // Initialize DataTable
      this.dataTableInstance = $("#datatable").DataTable({
        responsive: true,
        order: [[0, 'asc']],
        pageLength: 10,
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
        language: {
          search: "Search:",
          lengthMenu: "Show _MENU_ entries",
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "Showing 0 to 0 of 0 entries",
          infoFiltered: "(filtered from _MAX_ total entries)",
          paginate: {
            first: "First",
            last: "Last",
            next: "Next",
            previous: "Previous"
          }
        }
      });
    },

    isResigned(data) {
      return data.resign === 1 ? 'Resign' : 'Active'
    },

    getActiveStatus(data) {
      if (!data.expire_date) return data.resend === 1 ? "Resent" : "";

      const [year, month, day] = data.expire_date.split('-').map(Number);

      const expireDate = new Date(year, month - 1, day);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Check for expired
      if (data.status === 0 && data.resend !== 1 && expireDate < today) {
        return "Expired";
      } else if (data.resend === 1) {
        return "Resent";
      } else {
        return "";
      }
    },

    clearFilter() {
      if (this.dataTableInstance) {
        $.fn.dataTable.ext.search.pop();
        this.dataTableInstance.draw();
      }
    },
  },
  created() {
    this.getAssessmentTimeline();
    let intervalId;
    if (!this.employees.length) {
      intervalId = setInterval(() => {
        this.employees = this.$store.getters["odoo/getAllEmployees"] || [];
        if (this.employees.length) {
          clearInterval(intervalId);
        }
      }, 1000);
    }
  },

  beforeUnmount() {
    // Clean up DataTable instance when component is destroyed
    if (this.dataTableInstance) {
      this.dataTableInstance.destroy();
    }
  },
};
</script>

<style scoped>
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #4a81d4;
  border-color: #4a81d4;
}

.action-icon {
  cursor: pointer;
  font-size: 18px;
  text-decoration: none;
}

.action-icon:hover {
  opacity: 0.8;
}

.badge {
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.text-muted {
  color: #6c757d !important;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>